export default __webpack_public_path__ + "static/media/myresultsbeacon-01.81cd2703.svg";